import React from 'react';
import PropTypes from 'prop-types';

class Dimmer extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="Dimmer">
                <style jsx>{`
                    .Dimmer {
                        background:rgba(0,0,0,0.8);
                        position:fixed;
                        top:0px;
                        left:0px;
                        right:0px;
                        bottom:0px;
                        z-index:1000;
                        display:flex;
                        justify-items : center;
                        align-items : center;
                        justify-content : center;
                    }
                `}</style>
                {this.props.children}
            </div>
        )
    }
}

Dimmer.propTypes = {
    
}

export default Dimmer;


// WEBPACK FOOTER //
// ./src/components/common/Dimmer.js